import React, { createContext, useContext } from 'react';
import useNavHook from '../hooks/useNav';

export const NavContext = createContext();

export const NavProvider = ({ children }) => {
  const nav = useNavHook();

  return (
    <NavContext.Provider value={nav}>
      {children}
    </NavContext.Provider>
  );
};

export const useNav = () => useContext(NavContext);